<div class="container">
  <mic-breadcrumb id="casing-credit-breadcrumb">
    <mic-breadcrumb-link link="/home/dashboard" icon="home"></mic-breadcrumb-link>
    <mic-breadcrumb-link label="{{ translationService.translate('productDataText') }}"></mic-breadcrumb-link>
    <mic-breadcrumb-link label="{{ translationService.translate('casingCreditText') }}"></mic-breadcrumb-link>
  </mic-breadcrumb>

  <div class="casing-credit-header">
    <h2 class="page-title casing-credit-heading" id="casing-credit-heading">{{ translationService.translate('casingCreditText') }}</h2>
    <div class="action-bar">
      <button
        id="clear-filters"
        type="button"
        mat-flat-button
        color="accent"
        class="btn-clear casing-credit-action-button"
        (click)="clearFilters()"
      >
        <mat-icon>refresh</mat-icon> {{ translationService.translate('clearFiltersText') }}
      </button>
      <button
        id="add-button"
        type="button"
        mat-flat-button
        color="primary"
        class="btn-primary casing-credit-action-button"
        (click)="createCasingCredit()"
      >
        <mat-icon>add</mat-icon> {{ translationService.translate('createButtonText') }}
      </button>
    </div>
  </div>

  <mat-card class="casing-credit-filter-card">
    <form [formGroup]="filterForm">
      <div class="grid-container">
        <app-dropdown-search-single-select
          id="codeDropdown"
          label="{{ translationService.translate('codeText') }}"
          emptyPlaceholder="{{ translationService.translate('selectText') + ' ' + translationService.translate('codeText') }}"
          placeholder="{{ translationService.translate('selectText') + ' ' + translationService.translate('codeText') }}"
          [formGroup]="filterForm"
          formControlName="code"
          [data]="codesList"
        >
        </app-dropdown-search-single-select>
        <app-dropdown-search-single-select
          id="descriptionDropdown"
          label="{{ translationService.translate('descriptionText') }}"
          emptyPlaceholder="{{ translationService.translate('selectText') + ' ' + translationService.translate('descriptionText') }}"
          placeholder="{{ translationService.translate('selectText') + ' ' + translationService.translate('descriptionText') }}"
          [formGroup]="filterForm"
          formControlName="description"
          [data]="descriptionList"
        >
        </app-dropdown-search-single-select>
      </div>
    </form>
  </mat-card>

  <div id="casing-credit-table" class="cam-table table-container btn-table">
    <div class="table-wrapper">
      <mic-table appCopyOnSelect class="table-stripped" [config]="tableConfig" [fetcher]="fetcher">
        <ng-container *micTableNoData>
          <mic-empty-state icon="layers_clear" [title]="translationService.translate('emptyTableText')"></mic-empty-state>
        </ng-container>
        <ng-container id="table-menu" *micTableRowMenu="let item">
          <span
            [matTooltip]="
              isDeletable(item)
                ? translationService.translate('canNotDeleteBecauseText') + ' ' + translationService.translate('itemIsInUseText')
                : ''
            "
            matTooltipPosition="below"
          >
            <button id="delete-button" type="button" [disabled]="isDeletable(item)" mat-menu-item (click)="deleteCasingCredit(item)">
              <mat-icon>delete</mat-icon> {{ translationService.translate('deleteText') }}
            </button>
          </span>
          <button id="copy-button" type="button" mat-menu-item (click)="copyCasingCredit(item)">
            <mat-icon>content_copy</mat-icon> {{ translationService.translate('copyText') }}
          </button>
          <button
            [disabled]="this.productSaveDisabled"
            id="assign-to-customer-button"
            type="button"
            mat-menu-item
            (click)="assignToCustomer(item)"
          >
            <mat-icon>person_add_alt</mat-icon> {{ translationService.translate('assignToCustomerMenuText') }}
          </button>
        </ng-container>
      </mic-table>
    </div>
  </div>
</div>
